import React, { useEffect, useState } from "react";
import { Card, Stack } from "react-bootstrap";
import { Tab } from "@mui/material";
import { ScrollableTabsSelected } from "../../../../components/CustomMUIComponents";
import { useSelector } from "react-redux";

export default function TopPerformers({ title }) {
  const { DistributorDashboardData } = useSelector(
    (state) => state.DISTRUBUTORDASHBOARD
  );
  const [months, setMonths] = useState([
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ]);
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [selectedTab, setSelectedTab] = useState(4);
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    const months = DistributorDashboardData?.data?.top_performer?.map(
      (time) => time.month
    );
    setMonths(months ?? []);
    setAllData(DistributorDashboardData?.data?.top_performer ?? []);
  }, [DistributorDashboardData]);

  useEffect(() => {
    if (selectedTab) {
      const currentData = allData[selectedTab]?.data ?? [];
      const foundArray = [...currentData];
      if (currentData?.length > 0) {
        const sortedDistributors = foundArray?.sort(
          (a, b) => a?.rank - b?.rank
        );
        setData(sortedDistributors ?? []);
      }
    }
  }, [selectedTab, allData]);

  return (
    <Card className="dashboard_cards h-100" style={{ border: "none" }}>
      <Card.Body className="d-flex flex-column row-gap-3">
        <Card.Title style={{ fontWeight: "500" }} className="m-0 text_gray">
          {title}
        </Card.Title>
        {DistributorDashboardData?.data?.top_performer?.length > 0 ? (
          <>
            <Stack className="row-gap-3">
              {data.map((dataItem, key) => {
                return (
                  <Stack
                    direction="horizontal"
                    style={{ backgroundColor: "#E5F0FF", padding: "5px 10px" }}
                    className="gap-2 flex-wrap"
                    key={key}
                  >
                    <Stack
                      direction="horizontal"
                      className="flex-grow-1 column-gap-2 align-items-start"
                    >
                      <div
                        style={{
                          height: "40px",
                          width: "40px",
                          background: "#D9D9D9",
                        }}
                        className="flex-shrink-0"
                      />
                      <p
                        className="m-0 fw-bold text-break"
                        style={{ color: "#16161D" }}
                      >
                        {dataItem?.name}
                      </p>
                    </Stack>
                    <p
                      className="m-0 fw-bold text-break"
                      style={{ color: "#16161D" }}
                    >
                      {dataItem?.count}
                    </p>
                  </Stack>
                );
              })}
            </Stack>
            <ScrollableTabsSelected
              value={selectedTab}
              onChange={handleTabChange}
              variant="scrollable"
            >
              {months?.map((item, index) => (
                <Tab key={index} label={item} />
              ))}
            </ScrollableTabsSelected>
          </>
        ) : (
          <p className="m-0">No data found</p>
        )}
      </Card.Body>
    </Card>
  );
}
